/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SomniaTokenSummaryInfo } from './SomniaTokenSummaryInfo';

export type SomniaAccountPortfolioTokenInfo = {
    ADDR: SomniaTokenSummaryInfo;
    TKNT: SomniaAccountPortfolioTokenInfo.TKNT;
    PRC: string;
    AMT: string;
    VAL: string;
};

export namespace SomniaAccountPortfolioTokenInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

